var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79545 17.5013C7.38306 18.0199 8.15493 18.3346 9.0003 18.3346C9.84567 18.3346 10.6175 18.0199 11.2052 17.5013M14.0003 6.66797C14.0003 5.34189 13.4735 4.07012 12.5358 3.13243C11.5982 2.19475 10.3264 1.66797 9.0003 1.66797C7.67422 1.66797 6.40245 2.19475 5.46477 3.13243C4.52708 4.07012 4.0003 5.34189 4.0003 6.66797C4.0003 9.24312 3.35069 11.0063 2.62502 12.1725C2.01291 13.1562 1.70685 13.6481 1.71807 13.7853C1.7305 13.9372 1.76268 13.9951 1.88511 14.086C1.99568 14.168 2.49413 14.168 3.49101 14.168H14.5096C15.5065 14.168 16.0049 14.168 16.1155 14.086C16.2379 13.9951 16.2701 13.9372 16.2825 13.7853C16.2938 13.6481 15.9877 13.1562 15.3756 12.1725C14.6499 11.0063 14.0003 9.24312 14.0003 6.66797Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.b618cd496d938ee0bc4caccc4188c038.svg";
export { ForwardRef as ReactComponent };